import React, { useState, useEffect } from 'react';
import axios from 'axios';

const UploadVideo = () => {
  const [courses, setCourses] = useState([]);
  const [videos, setVideos] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState('');
  const [videoUrl, setVideoUrl] = useState('');
  const [videoName, setVideoName] = useState('');
  const [lectureName, setLectureName] = useState('');
  const [duration, setDuration] = useState('');
  const [description, setDescription] = useState('');  // New state for description
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchCourses();
    fetchVideos();
  }, []);

  const fetchCourses = async () => {
    try {
      const response = await axios.get('https://schoolofservice.co.za/backend/fetch_courses.php');
      if (response.data.status === 'success') {
        setCourses(response.data.data);
      } else {
        setMessage('Failed to load courses.');
      }
    } catch (error) {
      setMessage('An error occurred while fetching courses.');
    }
  };

  const fetchVideos = async () => {
    try {
      const response = await axios.get('https://schoolofservice.co.za/backend/fetch_videos.php');
      if (response.data.status === 'success') {
        setVideos(response.data.data);
      } else {
        setMessage('Failed to load videos.');
      }
    } catch (error) {
      setMessage('An error occurred while fetching videos.');
    }
  };

  const extractYouTubeVideoID = (url) => {
    const match = url.match(
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
    );
    return match ? match[1] : null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!videoUrl || !selectedCourse || !videoName || !lectureName || !duration || !description) {
      setMessage('Please provide all the required fields.');
      return;
    }

    const videoId = extractYouTubeVideoID(videoUrl);
    if (!videoId) {
      setMessage('Invalid YouTube URL. Please provide a valid YouTube video link.');
      return;
    }

    const embedUrl = `https://www.youtube-nocookie.com/embed/${videoId}?controls=1&mute=1&rel=0`;

    const formData = new FormData();
    formData.append('videoUrl', embedUrl);
    formData.append('courseId', selectedCourse);
    formData.append('videoName', videoName);
    formData.append('lectureName', lectureName);
    formData.append('duration', duration);
    formData.append('description', description);  // Appending the description to formData

    try {
      const response = await axios.post('https://schoolofservice.co.za/backend/upload_video.php', formData);
      if (response.data.status === 'success') {
        setMessage('Video link uploaded successfully.');
        fetchVideos();
      } else {
        setMessage(response.data.message || 'Failed to upload video link.');
      }
    } catch (error) {
      setMessage('An error occurred while uploading the video link.');
    }
  };

  return (
    <div>
      <h3>Upload Video Link</h3>
      {message && <div className="alert alert-info">{message}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="videoUrl" className="form-label">Video URL</label>
          <input type="url" className="form-control" id="videoUrl" value={videoUrl} onChange={(e) => setVideoUrl(e.target.value)} required />
        </div>
        <div className="mb-3">
          <label htmlFor="videoName" className="form-label">Video Name</label>
          <input type="text" className="form-control" id="videoName" value={videoName} onChange={(e) => setVideoName(e.target.value)} required />
        </div>
        <div className="mb-3">
          <label htmlFor="lectureName" className="form-label">Lecture Name</label>
          <input type="text" className="form-control" id="lectureName" value={lectureName} onChange={(e) => setLectureName(e.target.value)} required />
        </div>
        <div className="mb-3">
          <label htmlFor="duration" className="form-label">Video Duration</label>
          <input type="text" className="form-control" id="duration" value={duration} onChange={(e) => setDuration(e.target.value)} required />
        </div>
        <div className="mb-3">
          <label htmlFor="description" className="form-label">Video Description</label>
          <textarea className="form-control" id="description" rows="3" value={description} onChange={(e) => setDescription(e.target.value)} required></textarea>
        </div>
        <div className="mb-3">
          <label htmlFor="courseSelection" className="form-label">Select Course</label>
          <select className="form-select" id="courseSelection" value={selectedCourse} onChange={(e) => setSelectedCourse(e.target.value)} required>
            <option value="">Select Course</option>
            {courses.map((course) => (
              <option key={course.coursesID} value={course.coursesID}>{course.courseName}</option>
            ))}
          </select>
        </div>
        <button type="submit" className="btn btn-primary">Upload Video Link</button>
      </form>

      <h3 className="mt-4">Uploaded Videos</h3>
      {videos.length > 0 ? (
        <div className="d-flex flex-wrap">
          {videos.map((video) => (
            <div className="card m-2" style={{ width: '18rem' }} key={video.videoID}>
              <iframe className="card-img-top" src={video.videoUrl} title={video.videoName} style={{ width: '100%', height: '200px' }} frameBorder="0" allow="encrypted-media" allowFullScreen></iframe>
              <div className="card-body">
                <h5 className="card-title">{video.videoName}</h5>
                <p className="card-text">
                  <strong>Lecture:</strong> {video.lectureName} <br />
                  <strong>Duration:</strong> {video.duration} <br />
                  <strong>Description:</strong> {video.description} <br /> {/* Displaying description */}
                  <strong>Course:</strong> {video.courseName} <br />
                  <strong>Upload Time:</strong> {video.uploadTime}
                </p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p>No videos available.</p>
      )}
    </div>
  );
};

export default UploadVideo;
